import styled from '@emotion/styled';
import Subheading from '../headings/Subheading';
import { ContentWrap, Css, Responsive } from '../../../ui';

export default function GatewayHeader() {
	return (
		<StyledContentWrap>
			<h1>
				<Subheading type="h1">Welcome to</Subheading>
				Houston Airports
			</h1>
		</StyledContentWrap>
	);
}

const StyledContentWrap = styled(ContentWrap)`
	h1 {
		font-size: ${Css.pxToRem(185)};
		max-width: 100%;
		line-height: normal;
		margin-bottom: 0;

		@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
			font-size: ${Css.pxToRem(150)};
		}

		@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
			font-size: ${Css.pxToRem(100)};
		}

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			font-size: ${Css.pxToRem(32)};
			font-weight: 500;
			margin-bottom: ${Css.pxToRem(16)};

			.subheading {
				font-size: ${Css.pxToRem(19)};
			}
		}
	}
`;
